import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import * as VueGoogleMaps from 'vue2-google-maps'
import Vuelidate from 'vuelidate'
import VueGoogleCharts from 'vue-google-charts'
import router from "./router";
import store from "./store";
import VueYoutube from 'vue-youtube'


Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAP_API,
    libraries: 'places',
    region: 'EN',
    language: 'en'
  }
})
Vue.use(Vuelidate)
Vue.use(VueGoogleCharts)
Vue.use(VueYoutube)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
